<div class="h-100 single-report-page">
    <app-admin-report [columns]="undeliveredPackagesReport" [hasFilters]="true" [apiUrl]="undeliveredPackagesReportAPI"
                      reportTitle="ADMINISTRATION.UNDELIVERED_PACKAGES_SUMMARY_REPORT_TITLE">
    </app-admin-report>
</div>